import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faFilter } from '@fortawesome/free-solid-svg-icons';
const ResetFilterIcon = props => /*#__PURE__*/React.createElement(Button, {
  color: "link",
  onClick: props.onClick,
  title: "Reset Filter",
  className: "align-self-center"
}, /*#__PURE__*/React.createElement("span", {
  className: "fa-layers fa-fw"
}, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  color: "#ffdd99",
  icon: faFilter,
  transform: "grow-10"
}), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  color: "#ccc",
  icon: faBan,
  transform: "grow-3"
})));
export default ResetFilterIcon;